<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <vs-row class="my-2">
      <div class="flex flex-wrap-reverse items-center data-list-btn-container">

        <!-- ACTION - DROPDOWN -->
        <!-- <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

          <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
            <span class="mr-2">Acciones</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Delete</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Archive</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Print</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Another Action</span>
              </span>
            </vs-dropdown-item>

          </vs-dropdown-menu>
        </vs-dropdown> -->

        <!-- ADD NEW -->
        <div class="btn-add-new p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          @click="$modal.show('newEventModal');">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Agregar Consulta</span>
        </div>
      </div>
    </vs-row>

    <vs-table ref="table"  v-model="selected" v-if="consultationsList[1].length > 0"  :max-items="5"  :data="consultationsList[1]" >

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <h3>
          Atrasadas
        </h3>
      </div>

      <template slot="thead">
        <vs-th sort-key="id">#</vs-th>
        <vs-th sort-key="patient.first_name">Paciente</vs-th>
        <vs-th sort-key="type">Tipo</vs-th>
        <vs-th sort-key="date">Fecha</vs-th>
        <vs-th sort-key="date">Hora</vs-th>
        <vs-th sort-key="status">Estado</vs-th>
        <vs-th ></vs-th>
        <vs-th>Acciones</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <a href=""><p class="font-small truncate">{{ `${data[indextr].id}` }}</p></a>
              </vs-td>
              <vs-td>
                <a href=""><p class="font-medium truncate">{{ `${data[indextr].patient.first_name} ${data[indextr].patient.last_name}` }}</p></a>
              </vs-td>

              <vs-td>
                <vs-chip :color="getOrderTypeColor(data[indextr].type)" class="product-order-status shadow">{{ getOrderTypeTxt( data[indextr].type) }}</vs-chip>
              </vs-td>

              <vs-td :data="data[indextr].date">
                <p>{{ getDateString(data[indextr].date) }}</p>
              </vs-td>

              <vs-td>
                <p>{{ getTimeString(data[indextr].date) }}</p>
              </vs-td>

              <vs-td v-if="tr.meta">
                <vs-chip :color="getOrderStatusColor(tr.meta.status)" class="mt-1 product-order-status">{{ data[indextr].meta.status }}</vs-chip>
                <img class="ml-1 mt-1 zoom" @click="editStatus(tr)" src="https://img.icons8.com/material-sharp/24/000000/edit--v1.png"/>
              </vs-td>

              <vs-td v-if="!isSecretary">
                <!-- <p class="product-price">Q{{ tr.price }}</p> -->
                <vs-button  class="small" v-if="activeUserInfo.role=='doctor'" @click="showModalParam(tr)">Iniciar</vs-button>
                <vs-button class="small" v-if="activeUserInfo.role=='enfermera'" @click="$router.push('/consultations/signosvitales/?consultationId='+tr.id)">Signos Vitales</vs-button>
              </vs-td>
              

              <vs-td v-if="isSecretary">
                
              </vs-td>


              <vs-td class="whitespace-no-wrap">
                <img v-if="data[indextr].type == 'virtual_consultation' && data[indextr].clinic.meta.type.toLowerCase() == 'virtual'" class="mr-2 mt-1 zoom" @click="goZM(data[indextr])" src="https://img.icons8.com/ios/24/000000/zoom.png"/>
                <img class="mr-2 mt-1 zoom" @click="goWP(tr.patient.phone[0], tr.id, tr.patient.id)" src="https://img.icons8.com/fluent-systems-regular/24/000000/whatsapp.png"/>
                <img class="mr-2 mt-1 zoom" @click="editEvent(tr)" src="https://img.icons8.com/material-sharp/24/000000/edit--v1.png"/>
                <!-- <feather-icon icon="FileIcon" svgClasses="w-6 h-6 hover:text-success stroke-current" class="mr-3" /> -->
                <!-- <feather-icon icon="EditIcon" svgClasses="w-6 h-6 hover:text-warning stroke-current" @click.stop="editData(tr)" /> -->
                <!-- <feather-icon icon="TrashIcon" svgClasses="w-6 h-6 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    
    <vs-table ref="table"  v-model="selected" v-if="consultationsList[4].length > 0"  :max-items="5"  :data="consultationsList[4]" >

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <h3>
          Hoy
        </h3>
      </div>

      <template slot="thead">
        <vs-th sort-key="id">#</vs-th>
        <vs-th sort-key="patient.first_name">Paciente</vs-th>
        <vs-th sort-key="type">Tipo</vs-th>
        <vs-th sort-key="date">Fecha</vs-th>
        <vs-th sort-key="date">Hora</vs-th>
        <vs-th sort-key="status">Estado</vs-th>
        <vs-th ></vs-th>
        <vs-th>Acciones</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <a href=""><p class="font-small truncate">{{ `${data[indextr].id}` }}</p></a>
              </vs-td>
              <vs-td>
                <a href=""><p class="font-medium truncate">{{ `${data[indextr].patient.first_name} ${data[indextr].patient.last_name}` }}</p></a>
              </vs-td>

              <vs-td>
                <vs-chip :color="getOrderTypeColor(data[indextr].type)" class="product-order-status shadow">{{ getOrderTypeTxt( data[indextr].type) }}</vs-chip>
              </vs-td>

              <vs-td :data="data[indextr].date">
                <p>{{ getDateString(data[indextr].date) }}</p>
              </vs-td>

              <vs-td>
                <p>{{ getTimeString(data[indextr].date) }}</p>
              </vs-td>

              <vs-td v-if="tr.meta">
                <vs-chip :color="getOrderStatusColor(tr.meta.status)" class="mt-1 product-order-status">{{ data[indextr].meta.status }}</vs-chip>
                <img class="ml-1 mt-1 zoom" @click="editStatus(tr)" src="https://img.icons8.com/material-sharp/24/000000/edit--v1.png"/>
              </vs-td>

              <vs-td v-if="!isSecretary">
                <!-- <p class="product-price">Q{{ tr.price }}</p> -->
                <vs-button class="small" @click="$router.push('/consultations/newConsultation/?consultationId='+tr.id)">Iniciar</vs-button>
                
              </vs-td>

              <vs-td v-if="isSecretary">
                
              </vs-td>


              <vs-td class="whitespace-no-wrap">
                <img v-if="data[indextr].type == 'virtual_consultation' && data[indextr].clinic.meta.type.toLowerCase() == 'virtual'" class="mr-2 mt-1 zoom" @click="goZM(data[indextr])" src="https://img.icons8.com/ios/24/000000/zoom.png"/>
                <img class="mr-2 mt-1 zoom" @click="goWP(tr.patient.phone[0], tr.id, tr.patient.id)" src="https://img.icons8.com/fluent-systems-regular/24/000000/whatsapp.png"/>
                <img class="mr-2 mt-1 zoom" @click="editEvent(tr)" src="https://img.icons8.com/material-sharp/24/000000/edit--v1.png"/>
                <!-- <feather-icon icon="FileIcon" svgClasses="w-6 h-6 hover:text-success stroke-current" class="mr-3" /> -->
                <!-- <feather-icon icon="EditIcon" svgClasses="w-6 h-6 hover:text-warning stroke-current" @click.stop="editData(tr)" /> -->
                <!-- <feather-icon icon="TrashIcon" svgClasses="w-6 h-6 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <vs-table ref="table" v-if="consultationsList[3].length > 0" v-model="selected"  :max-items="5"  :data="consultationsList[3]" >

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <h3>
          Mañana
        </h3>
      </div>

      <template slot="thead">
        <vs-th sort-key="id">#</vs-th>
        <vs-th sort-key="patient.first_name">Paciente</vs-th>
        <vs-th sort-key="type">Tipo</vs-th>
        <vs-th sort-key="date">Fecha</vs-th>
        <vs-th sort-key="date">Hora</vs-th>
        <vs-th sort-key="status">Estado</vs-th>
        <vs-th ></vs-th>
        <vs-th>Acciones</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <a href=""><p class="font-small truncate">{{ `${data[indextr].id}` }}</p></a>
              </vs-td>
              <vs-td>
                <a href=""><p class="font-medium truncate">{{ `${data[indextr].patient.first_name} ${data[indextr].patient.last_name}` }}</p></a>
              </vs-td>

              <vs-td>
                <vs-chip :color="getOrderTypeColor(data[indextr].type)" class="product-order-status shadow">{{ getOrderTypeTxt( data[indextr].type) }}</vs-chip>
              </vs-td>

              <vs-td :data="data[indextr].date">
                <p>{{ getDateString(data[indextr].date) }}</p>
              </vs-td>

              <vs-td>
                <p>{{ getTimeString(data[indextr].date) }}</p>
              </vs-td>

              <vs-td v-if="tr.meta">
                <vs-chip :color="getOrderStatusColor(tr.meta.status)" class="mt-1 product-order-status">{{ data[indextr].meta.status }}</vs-chip>
                <img class="ml-1 mt-1 zoom" @click="editStatus(tr)" src="https://img.icons8.com/material-sharp/24/000000/edit--v1.png"/>
              </vs-td>

              <vs-td v-if="!isSecretary">
                <!-- <p class="product-price">Q{{ tr.price }}</p> -->
                <vs-button class="small" @click="$router.push('/consultations/newConsultation/?consultationId='+tr.id)">Iniciar</vs-button>
              </vs-td>

              <vs-td v-if="isSecretary">
                
              </vs-td>


              <vs-td class="whitespace-no-wrap">
                <img v-if="data[indextr].type == 'virtual_consultation' && data[indextr].clinic.meta.type.toLowerCase() == 'virtual'" class="mr-2 mt-1 zoom" @click="goZM(data[indextr])" src="https://img.icons8.com/ios/24/000000/zoom.png"/>
                <img class="mr-2 mt-1 zoom" @click="goWP(tr.patient.phone[0], tr.id, tr.patient.id)" src="https://img.icons8.com/fluent-systems-regular/24/000000/whatsapp.png"/>
                <img class="mr-2 mt-1 zoom" @click="editEvent(tr)" src="https://img.icons8.com/material-sharp/24/000000/edit--v1.png"/>
                <!-- <feather-icon icon="FileIcon" svgClasses="w-6 h-6 hover:text-success stroke-current" class="mr-3" /> -->
                <!-- <feather-icon icon="EditIcon" svgClasses="w-6 h-6 hover:text-warning stroke-current" @click.stop="editData(tr)" /> -->
                <!-- <feather-icon icon="TrashIcon" svgClasses="w-6 h-6 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>

    <vs-table ref="table" v-if="consultationsList[2].length > 0"  v-model="selected"  :max-items="5" search  :data="consultationsList[2]" >

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <h3>
          Próximas Consultas
        </h3>
      </div>

      <template slot="thead">
        <vs-th sort-key="id">#</vs-th>
        <vs-th sort-key="patient.first_name">Paciente</vs-th>
        <vs-th sort-key="type">Tipo</vs-th>
        <vs-th sort-key="date">Fecha</vs-th>
        <vs-th sort-key="date">Hora</vs-th>
        <vs-th sort-key="status">Estado</vs-th>
        <vs-th ></vs-th>
        <vs-th>Acciones</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <a href=""><p class="font-small truncate">{{ `${data[indextr].id}` }}</p></a>
              </vs-td>
              <vs-td>
                <a href=""><p class="font-medium truncate">{{ `${data[indextr].patient.first_name}`+ ` ` + `${data[indextr].patient.last_name}` }}</p></a>
              </vs-td>

              <vs-td>
                <vs-chip :color="getOrderTypeColor(data[indextr].type)" class="product-order-status shadow">{{ getOrderTypeTxt( data[indextr].type) }}</vs-chip>
              </vs-td>

              <vs-td :data="data[indextr].date">
                <p>{{ getDateString(data[indextr].date) }}</p>
              </vs-td>

              <vs-td>
                <p>{{ getTimeString(data[indextr].date) }}</p>
              </vs-td>

              <vs-td v-if="tr.meta">
                <vs-chip :color="getOrderStatusColor(tr.meta.status)" class="mt-1 product-order-status">{{ data[indextr].meta.status }}</vs-chip>
                <img class="ml-1 mt-1 zoom" @click="editStatus(tr)" src="https://img.icons8.com/material-sharp/24/000000/edit--v1.png"/>
              </vs-td>

              <vs-td v-if="!isSecretary">
                <!-- <p class="product-price">Q{{ tr.price }}</p> -->
                <vs-button class="small" @click="$router.push('/consultations/newConsultation/?consultationId='+tr.id)">Iniciar</vs-button>
              </vs-td>

              <vs-td v-if="isSecretary">
                
              </vs-td>


              <vs-td class="whitespace-no-wrap">
                <img v-if="data[indextr].type == 'virtual_consultation' && data[indextr].clinic.meta.type.toLowerCase() == 'virtual'" class="mr-2 mt-1 zoom" @click="goZM(data[indextr])" src="https://img.icons8.com/ios/24/000000/zoom.png"/>
                <img class="mr-2 mt-1 zoom" @click="goWP(tr.patient.phone[0], tr.id, tr.patient.id)" src="https://img.icons8.com/fluent-systems-regular/24/000000/whatsapp.png"/>
                <img class="mr-2 mt-1 zoom" @click="editEvent(tr)" src="https://img.icons8.com/material-sharp/24/000000/edit--v1.png"/>
                <!-- <feather-icon icon="FileIcon" svgClasses="w-6 h-6 hover:text-success stroke-current" class="mr-3" /> -->
                <!-- <feather-icon icon="EditIcon" svgClasses="w-6 h-6 hover:text-warning stroke-current" @click.stop="editData(tr)" /> -->
                <!-- <feather-icon icon="TrashIcon" svgClasses="w-6 h-6 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <modal
      name="editEventModal"
      height="auto"
      width="50%"
    > 
    <form data-vv-scope="new-event">
      <div class="p-3">
        <div class="vw-row w-full pl-2 pt-2">
            <h2>Editar Evento #{{edittingId}} </h2>
      </div>
      <vs-divider icon-pack="feather" class="mt-2" icon="icon-chevron-down" position="center" color="primary"></vs-divider>
       <div class="vx-row w-full mt-3">
              <div class="vx-col w-1/3">
                <p class="ml-3">Clínica<p/>
              </div>
              <div class="vx-col w-2/3 flex">
                <v-select class="inline w-full mr-2" :options="docClinics" label="title" 
                  v-validate="'required'"  name="clinica" 
                  :reduce="option => option.id"  v-model="eventData.clinic_id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :selectable="option => !(option.meta.zoom_active && option.meta.zoom_active.toLowerCase() == 'false')"
                >
                  <template v-slot:option="option">
                    <img class="mr-2 inline"  :src=" option.meta.type.toLowerCase() == 'virtual' ? 
                      'https://img.icons8.com/ios/24/000000/zoom.png' :
                      'https://img.icons8.com/material-outlined/24/000000/hospital-3.png' "/>
                    <p class="inline"
                      :class="(option.meta.type.toLowerCase() == 'virtual') && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                        ? 'text-danger' : 'text-primary'"
                    >{{ 
                      (option.meta.type.toLowerCase() == 'virtual')
                       && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                      ?  `${option.title} - Sin Activar` : option.title
                    }}</p>
                  </template>
                </v-select> 
                <div v-if="!eventData.clinic_id">
                  <vs-button class="inline" color="primary" type="gradient" icon="local_hospital" @click="$modal.show('newClinicModal');"></vs-button>
                </div>
              </div>
            </div>
       <div class="vx-row w-full mt-3">
            <div class="vx-col w-1/3">
              <p class="ml-3">Fecha<p/>
            </div>
            <div class="vx-col w-2/3">
              <flat-pickr class="w-full" :config="configdateTimePicker" v-model="eventData.date" placeholder="Fecha"
                v-validate="'required'" name="fecha" />
              <span class="text-danger w-full">{{ errors.first('new-event.fecha') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3" v-if="eventData.eventType !='recordatorio'">
            <div class="vx-col w-1/3">
              <p class="ml-3">Hora<p/>
            </div>
            <div class="vx-col w-2/3" >
              <v-select v-if="eventData.date && eventData.clinic_id" :options="clinicAvailabilityByDate" :dir="$vs.rtl ? 'rtl' : 'ltr'"
              name="hora" v-validate="'required'" class="w-full style-chooser"  v-model="eventData.hour" 
                :reduce="option => new Date(option.date1).toISOString().split('T')[1].substring(0,5)"
                :selectable="option => option.available"
              >
              <template slot="selected-option" slot-scope="option">
                  {{ `${convertUTC_TIME(option.date1)} - ${convertUTC_TIME(option.date2)}` }}
              </template>
                <template v-slot:option="option">
                  <p class="inline" :class="option.available ? 'text-primary' : 'text-danger'">{{ 
                    `${convertUTC_TIME(option.date1)} - ${convertUTC_TIME(option.date2)}`
                  }}</p>
                  <small v-if="!option.available" class="ml-2 text-danger">
                    No Disponible
                  </small>
                </template>
              </v-select>
              <p class="my-1 text-secondary" v-else >Selecciona una fecha y clínica para determinar la disponibilidad</p>
              <span class="text-danger">{{ errors.first('new-event.hora') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3" v-if="eventData.eventType !='recordatorio'">
            <div class="vx-col w-1/3">
              <p class="ml-3">Duración<p/>
            </div>
            <div class="vx-col w-2/3">
              <p class="ml-6">
                <strong>{{eventData.duration}} minutos</strong>
              </p>
              <vs-input-number style="display:none" color="primary" v-model="eventData.duration" :step="5" disabled readonly label="Minutos:" :min="10"  :max="180"
                v-validate="'required|max_value:180|min_value:10'" name="duracion" />
              <span class="text-danger w-full">{{ errors.first('new-event.duracion') }}</span>
            </div>
          </div>
          <!-- <div v-if="eventData.timeType == 'normal' && eventData.eventType !== 'recordatorio'">
            <div class="vx-row w-full mt-3">
              <div class="vx-col w-full">
                <p class="ml-5">Horas Disponibles<p/>
              </div>
              <div class="vx-col w-full text-center my-2">
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '10:20'">10:20</vs-button>
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '11:30'">11:30</vs-button>
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '13:00'">13:00</vs-button>
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '15:30'">15:30</vs-button>
              </div>
            </div>
          </div> -->
          <div v-if="eventData.timeType == 'advanced' && eventData.eventType !== 'recordatorio'">
            <div class="vx-row w-full mt-3">
              <div class="vx-col w-1/2 flex">
                <p class="my-1 ml-3 text-center inline">Inicio</p>
                <flat-pickr :config="configdateTimePicker" v-model="eventData.time1" placeholder="Inicio" class="w-full inline ml-3"/>
              </div>
              <div class="vx-col w-1/2 flex">
                <p class="my-1 text-center inline">Fin</p>
                <flat-pickr :config="configdateTimePicker" v-model="eventData.time2" placeholder="Fin" class="w-full inline ml-3" />
              </div>
            </div>
          </div>
          <div class="vx-row w-full mt-3">
            <div class="vx-col w-1/3">
              <p class="my-1 ml-3">Titulo</p>
            </div>
            <div class="vx-col w-2/3">
              <vs-input name="titulo" v-validate="'required'" class="w-full"  v-model="eventData.title"></vs-input>
               <span class="text-danger w-full">{{ errors.first('new-event.titulo') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3">
            <div class="vx-col w-1/3">
              <p class="my-1 ml-3">Notas</p>
            </div>
            <div class="vx-col w-2/3">
              <vs-textarea name="notas" v-validate="''" v-model="eventData.notes" height="50px" />
               <span class="text-danger w-full">{{ errors.first('new-event.notas') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3" v-if="false">
            <div class="vx-col w-full flex flex-col items-center">
              <vs-checkbox color="success" v-model="eventData.notification">Notificar</vs-checkbox>
            </div>
          </div>
          <div class="items-center flex">
                <vs-button class="px-5 inline" color="success" type="filled" @click="validateAddNewEvent('edit')">Guardar</vs-button>
                <vs-button class="px-5 ml-5" color="danger" type="filled" @click="cancelEditEvent()">Cancelar</vs-button>
          </div>
      </div>
    </form>
    </modal>
    <modal
      name="newEventModal"
      height="auto"
      width="50%"
      style="z-index:1000;"
      classes="overflow"
    >
      <form data-vv-scope="new-event">
        <div class="p-3 ">
          <div class="vw-row w-full pl-2 pt-2"><h2>Nueva Consulta</h2></div>
          <div class="vx-row w-full">
            <div class="vx-col w-full">
              <h5 class="ml-3 mt-4">Tipo de Evento</h5>
            </div>
            <div class="vx-col w-full mt-3 ml-3">
              
              <div @click="eventData.eventType = 'consulta'">
                <vs-chip class="py-1 mr-4" :color="eventData.eventType == 'consulta' ? '#0034A1' : '#a0a4a5'">
                  <vs-icon class="mr-3" icon="assignment_ind"/>
                  <p style="font-size:14px">Consulta</p>
                </vs-chip>
              </div>
            </div>
          </div>

        <vs-divider icon-pack="feather" class="mt-2" icon="icon-chevron-down" position="center" color="primary"></vs-divider>
        <div v-if="eventData.eventType">
          <div>     
            <div class="vx-row w-full mt-3" v-if="eventData.eventType == 'consulta'">
              <div class="vx-col w-1/3">
                <p class="ml-3">Clínica<p/>
              </div>
              <div class="vx-col w-2/3 flex">
                <v-select class="inline w-full mr-2" :options="docClinics" label="title" 
                  v-validate="'required'"  name="clinica" 
                  :reduce="option => option.id"  v-model="eventData.clinic_id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :selectable="option => !(option.meta.zoom_active && option.meta.zoom_active.toLowerCase() == 'false')"
                >
                  <template v-slot:option="option">
                    <img class="mr-2 inline"  :src=" option.meta.type.toLowerCase() == 'virtual' ? 
                      'https://img.icons8.com/ios/24/000000/zoom.png' :
                      'https://img.icons8.com/material-outlined/24/000000/hospital-3.png' "/>
                    <p class="inline"
                      :class="(option.meta.type.toLowerCase() == 'virtual') && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                        ? 'text-danger' : 'text-primary'"
                    >{{ 
                      (option.meta.type.toLowerCase() == 'virtual')
                       && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                      ?  `${option.title} - Sin Activar` : option.title
                    }}</p>
                  </template>
                </v-select> 
                <div v-if="!eventData.clinic_id">
                  <vs-button class="inline" color="primary" type="gradient" icon="local_hospital" @click="$modal.show('newClinicModal');"></vs-button>
                </div>
              </div>
            </div>
            <div class="vx-row w-full" v-if="(eventData.eventType == 'consulta')">
              <div class="vx-col w-1/3">
              </div>
              <div class="vx-col w-2/3 flex">
                <span class="text-danger">{{ errors.first('new-event.clinica') }}</span>
              </div>
            </div>
            <div class="vx-row w-full mt-1 mb-4" v-if="eventData.eventType == 'consulta' && !(findZoomClinicsActive.length>0)">
              <p class="ml-3 w-full text-center"  style="font-size: 13px; color:#00a7e1 ">
                *Para activar tu clinica virtual de Zoom debes ir a:
                <span @click="goSettings" class="ml-2" style="font-weight: 600">
                  <feather-icon
                    icon='SettingsIcon'
                    svgClasses="w-4 h-4 m-1"
                    class="" />
                  Ajustes/Conexiones
                </span>
              </p>
            </div>
            <div class="vx-row w-full mt-3" v-if="(eventData.eventType == 'consulta')">
              <div class="vx-col w-1/3">
                <p class="ml-3">Paciente<p/>
              </div>
              <div class="vx-col w-2/3 flex">
                <v-select class="inline w-full mr-2" :options="patientsList" label="first_name" :filter-by="patientFilter" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-validate="'required'" name="paciente" :reduce="option => option.id" v-model="eventData.patient_id" >
                    <template v-slot:option="option">
                      {{ option.first_name }} {{option.last_name}} ({{option.email}})
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        {{ option.first_name }} {{option.last_name}} ({{option.email}})
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        No se encontraron pacientes para: <em>{{ search }}</em>.
                      </template>
                      <em style="opacity: 0.5;" v-else>Escribir para buscar pacientes.</em>
                    </template>
                </v-select>
                <div v-if="!eventData.patient_id">
                  <vs-button class="inline" color="primary" type="gradient" icon-pack="feather" icon="icon-user-plus" @click="$modal.show('newPatientModal');"></vs-button>
                </div>
              </div>
            </div>
            <div class="vx-row w-full" v-if="(eventData.eventType == 'consulta')">
              <div class="vx-col w-1/3">
              </div>
              <div class="vx-col w-2/3 flex">
                <span class="text-danger w-full">{{ errors.first('new-event.paciente') }}</span>
              </div>
            </div>
          </div>        
          <div class="vx-row w-full mt-3">
            <div class="vx-col w-1/3">
              <p class="ml-3">Fecha<p/>
            </div>
            <div class="vx-col w-2/3">
              <flat-pickr class="w-full" :config="configdateTimePicker" v-model="eventData.date" placeholder="Fecha"
                v-validate="'required'" name="fecha" />
              <span class="text-danger w-full">{{ errors.first('new-event.fecha') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3" v-if="eventData.eventType !='recordatorio'">
            <div class="vx-col w-1/3">
              <p class="ml-3">Hora<p/>
            </div>
            <div class=" inline vx-col w-2/3" >
              <v-select height="100px" v-if="eventData.date && eventData.clinic_id" :options="clinicAvailabilityByDate" :dir="$vs.rtl ? 'rtl' : 'ltr'"
              name="hora" v-validate="'required'" class=" w-full style-chooser"  v-model="eventData.hour" 
                :reduce="option => new Date(option.date1).toISOString().split('T')[1].substring(0,5)"
                :selectable="option => option.available"
              >
              <template slot="selected-option" slot-scope="option" style="z-index: 1000">
                  {{ `${convertUTC_TIME(option.date1)} - ${convertUTC_TIME(option.date2)}` }}
              </template>
                <template v-slot:option="option" style="z-index: 1000">
                  <p class="inline" :class="option.available ? 'text-primary' : 'text-danger'">{{ 
                    `${convertUTC_TIME(option.date1)} - ${convertUTC_TIME(option.date2)}`
                  }}</p>
                  <small v-if="!option.available" class="ml-2 text-danger">
                    No Disponible
                  </small>
                </template>
              </v-select>
              <p class="my-1 text-secondary" v-else >Selecciona una fecha y clínica para determinar la disponibilidad</p>
              <span class="text-danger">{{ errors.first('new-event.hora') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3" v-if="eventData.eventType !='recordatorio'">
            <div class="vx-col w-1/3">
              <p class="ml-3">Duración<p/>
            </div>
            <div class="vx-col w-2/3">
              <p class="ml-6">
                <strong>{{eventData.duration}} minutos</strong>
              </p>
              <vs-input-number style="display:none" color="primary" v-model="eventData.duration" :step="5" disabled readonly label="Minutos:" :min="10"  :max="180"
                v-validate="'required|max_value:180|min_value:10'" name="duracion" />
              <span class="text-danger w-full">{{ errors.first('new-event.duracion') }}</span>
            </div>
          </div>
          <!-- <div v-if="eventData.timeType == 'normal' && eventData.eventType !== 'recordatorio'">
            <div class="vx-row w-full mt-3">
              <div class="vx-col w-full">
                <p class="ml-5">Horas Disponibles<p/>
              </div>
              <div class="vx-col w-full text-center my-2">
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '10:20'">10:20</vs-button>
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '11:30'">11:30</vs-button>
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '13:00'">13:00</vs-button>
                <vs-button class="mx-1" color="success" type="border" @click="eventData.time1 = '15:30'">15:30</vs-button>
              </div>
            </div>
          </div> -->
          <div v-if="eventData.timeType == 'advanced' && eventData.eventType !== 'recordatorio'">
            <div class="vx-row w-full mt-3">
              <div class="vx-col w-1/2 flex">
                <p class="my-1 ml-3 text-center inline">Inicio</p>
                <flat-pickr :config="configdateTimePicker" v-model="eventData.time1" placeholder="Inicio" class="w-full inline ml-3"/>
              </div>
              <div class="vx-col w-1/2 flex">
                <p class="my-1 text-center inline">Fin</p>
                <flat-pickr :config="configdateTimePicker" v-model="eventData.time2" placeholder="Fin" class="w-full inline ml-3" />
              </div>
            </div>
          </div>
          <div class="vx-row w-full mt-3">
            <div class="vx-col w-1/3">
              <p class="my-1 ml-3">Titulo</p>
            </div>
            <div class="vx-col w-2/3">
              <vs-input name="titulo" v-validate="'required'" class="w-full"  v-model="eventData.title"></vs-input>
               <span class="text-danger w-full">{{ errors.first('new-event.titulo') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3">
            <div class="vx-col w-1/3">
              <p class="my-1 ml-3">Notas</p>
            </div>
            <div class="vx-col w-2/3">
              <vs-textarea name="notas" v-validate="''" v-model="eventData.notes" height="50px" />
               <span class="text-danger w-full">{{ errors.first('new-event.notas') }}</span>
            </div>
          </div>
          <div class="vx-row w-full mt-3" v-if="false">
            <div class="vx-col w-full flex flex-col items-center">
              <vs-checkbox color="success" v-model="eventData.notification">Notificar</vs-checkbox>
            </div>
          </div>
           <vs-divider class="my-6" />
          <div class="vx-row w-full mt-6">
            <div class="vx-col flex flex-col items-center w-full">
              <div v-if="!edittingEvent" class="">
              <vs-button class="px-5" color="primary" type="filled" @click="validateAddNewEvent('add')">Agregar</vs-button>
              </div>
              <div v-else class="items-center flex">
                <vs-button class="px-5 inline" color="success" type="filled" @click="validateAddNewEvent('edit')">Guardar</vs-button>
                <vs-button class="px-5 ml-5" color="danger" type="filled" @click="cancelEditEvent()">Cancelar</vs-button>
              </div>
          </div>
        </div>
        </div>
        </div>
      </form>
      
      <modal
          name="newPatientModal"
          height="auto"
          width="60%"
          style="z-index: 1005;"
        >
          <form data-vv-scope="new-patient">

          
            <div class="vx-row mt-6 mb-5 ml-1">
              <div class="vx-col w-full" >
              <h2>Nuevo Paciente</h2>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center" >
                <vs-input class="w-full px-5" label="Nombre(s)*" placeholder="Nombre(s)"
                name="nombres" v-validate="'required'" v-model="newPatient.first_name"/>
                <span class="text-danger">{{ errors.first('new-patient.nombres') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Apellidos(s)*" placeholder="Apellidos(s)"
                name="apellidos" v-validate="'required'" v-model="newPatient.last_name" />
                <span class="text-danger">{{ errors.first('new-patient.apellidos') }}</span>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Celular*" placeholder="Celular"
                name="celular" v-validate="'required|digits:8'" v-model="newPatient.phone[0]"/>
                <span class="text-danger">{{ errors.first('new-patient.celular') }}</span>
              </div>
              <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Número de teléfono" placeholder="Número de teléfono" 
                name="telefono" v-validate="''" v-model="newPatient.phone[1]"/>
                <span class="text-danger">{{ errors.first('new-patient.telefono') }}</span>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5">
              <div class="vx-col  w-full flex flex-col items-center">
                <vs-input class="w-full px-5" label="Correo Electrónico*" placeholder="Correo Electrónico"
                name="email" v-validate="''" v-model="newPatient.email"/>
                <span class="text-danger">{{ errors.first('new-patient.email') }}</span>
              </div>
            </div>
            <div class="vx-row mt-4 mb-5" v-if="false"> 
              <div class="vx-col  w-full flex flex-col items-center">
                <p>¿Desea enviar formulario de registro?</p>
                  <ul class="mt-2">
                    <li class="ml-3">
                      <vs-radio v-model="notifyPatient" name="notificar" v-validate="'required'" :vs-value="true">
                        Si
                      </vs-radio>
                    </li>
                    <li class="ml-3">
                      <vs-radio v-model="notifyPatient" name="notificar" v-validate="'required'" :vs-value="false">
                        No
                      </vs-radio>
                    </li>
                  </ul>
                  <span class="text-danger ml-5">{{ errors.first('new-patient.notificar') }}</span>
              </div>
            </div>
            <div v-if="registerPatient">
              <div class="vx-row mt-4 mb-4">
                <div class="vx-col w-full md:w-1/3 flex flex-col inline">
                    <p class="inline px-5 mb-3" style="font-size: 13px;">Sexo*</p>
                    <ul class="ml-6">
                      <li class="ml-3">
                        <vs-radio v-model="newPatient.gender" name="sexo" v-validate="'required'" vs-value="male">
                          Másculino
                        </vs-radio>
                      </li>
                      <li class="ml-3">
                        <vs-radio v-model="newPatient.gender" name="sexo" v-validate="'required'" vs-value="female">
                          Femenino
                        </vs-radio>
                      </li>
                    </ul>
                    <span class="text-danger ml-5">{{ errors.first('new-patient.sexo') }}</span>
                </div>
                <div class="vx-col w-full md:w-2/3 flex flex-col inline">
                    <p class="pl-5" style="font-size: 13px;">Fecha de Nacimiento*</p>
                    <datepicker class="px-5" placeholder="Seleccionar Fecha" format="yyyy-MM-dd" 
                      name="fecha_de_nacimiento" v-validate="'required'" v-model="newPatient.dob"></datepicker>
                    <span class="ml-5 text-danger">{{ errors.first('new-patient.fecha_de_nacimiento') }}</span>
                </div>
              </div>
              <div class="vx-row mt-4 mb-2">
                <div class="vx-col w-full md:w-full flex flex-col inline">
                    <p class="pl-5" style="font-size: 13px;">Identificación*</p>
                    <div class="vx-row">
                        <div class="vx-col w-1/3">
                            <v-select class="pl-5" placeholder="Documento" :options="['DPI','Cédula', 'Pasaporte']" :dir="$vs.rtl ? 'rtl' : 'ltr'"  
                            name="tipo" v-validate="'required'" v-model="newPatient.idtype" />
                            <span class="pl-5 text-danger">{{ errors.first('new-patient.tipo') }}</span>
                        </div>
                        <div class="vx-col w-2/3 ">
                            <vs-input class="px-5 inputx w-full"  placeholder="Número de identificación"
                              name="identificacion" v-validate="'required'" v-model="newPatient.idNum" />
                            <span class="ml-5 text-danger">{{ errors.first('new-patient.identificacion') }}</span>
                        </div>
                    </div>
                </div>
              </div>
              <div class="vx-row mb-1">
                <div class="vx-col w-full md:w-full flex flex-col inline">
                    <div class="vx-row">
                        <div class="vx-col w-1/2">
                            <p class="pl-5" style="font-size: 13px;">País</p>
                            <v-select class="pl-5" placeholder="País" :options="getCountries" :dir="$vs.rtl ? 'rtl' : 'ltr'"  
                            name="pais" label="name" v-validate="''" v-model="newPatient.country" />
                            <span class="pl-5 text-danger">{{ errors.first('new-patient.pais') }}</span>
                        </div>
                        <div class="vx-col w-1/2 ">
                          <p class="" style="font-size: 13px;">Ciudad</p>
                          <v-select 
                            :disabled="newPatient.country ? false : true" :options="newPatient.country ? getStates : []"
                            class="pr-5" placeholder="Ciudad" :dir="$vs.rtl ? 'rtl' : 'ltr'"  
                            name="ciudad" v-validate="''" v-model="newPatient.city" />
                          <span class="ml-5 text-danger">{{ errors.first('new-patient.ciudad') }}</span>
                        </div>
                    </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full md:w-full flex flex-col inline">
                    <div class="vx-row">
                        <div class="vx-col w-1/2">
                            <vs-input class="pl-5 inputx w-full" label="Dirección" placeholder="Dirección"
                              name="direccion" v-validate="''" v-model="newPatient.address" />
                            <span class="pl-5 text-danger">{{ errors.first('new-patient.direccion') }}</span>
                        </div>
                        <div class="vx-col w-1/2 ">
                            <vs-input class="pr-5 inputx w-full" label="Complemento" placeholder="Complemento dirección"
                              name="direccion_2" v-validate="''" v-model="newPatient.address_2" />
                            <span class="ml-5 text-danger">{{ errors.first('new-patient.direccion_2') }}</span>
                        </div>
                    </div>
                </div>
              </div>
              
            </div>
            
            <vs-divider class="mt-6 mb-5" />

            <div class="vx-row pt-3 pb-6">
              <div class="vx-col w-full flex justify-center">
                <vs-button class="mr-4" color="primary" type="filled" icon-pack="feather" icon="icon-mail"
                  v-if="!registerPatient" @click="validateNewPatient">
                  Agregar
                </vs-button>
                <!-- <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-list" 
                  v-if="!registerPatient" @click="registerPatient = !registerPatient">
                  Registrar Datos
                </vs-button>
                <vs-button color="danger" class="mr-4" type="filled" icon-pack="feather" icon="icon-list" 
                  v-if="registerPatient" @click="registerPatient = !registerPatient">
                  Cancelar
                </vs-button>
                <vs-button color="success" type="filled" icon-pack="feather" icon="icon-save" 
                  v-if="registerPatient" @click="validateNewPatient">
                  Registrar Usuario
                </vs-button> -->
              </div>
            </div>
          </form>
      </modal>

    </modal>
    <modal
          name="zoomModal"
          height="auto"
          width="50%"
          style="z-index: 1005;"
        >
          <vs-row vs-w="12" class="p-4">
            <vs-col vs-type="flex" class="my-6" vs-justify="center" vs-align="center" vs-w="12">
              <h3>Accesos de la consulta virtual #{{activeConsultationModal.id}}</h3>
            </vs-col>
            <vs-col vs-type="flex" class="" vs-justify="center" vs-align="center" vs-w="12">
              <img src="@/assets/images/logo/zoomLogo.png" alt="Zoom" style="width: 150px;">
            </vs-col>

          </vs-row>
          <vs-row vs-w="12" class="ml-4 mt-3 mb-2">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
              <p>Link de Accesso Público</p>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="pl-3">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <vs-input disabled class="inputx w-2/3" placeholder="Disabled" id="meeting_url_input" v-model="activeConsultationModal.meeting_url_base"/>
              <vs-button class="ml-3" color="primary" type="filled" icon="content_copy"
                v-clipboard:copy="activeConsultationModal.meeting_url_base"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              ></vs-button>

            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="ml-4 mt-6 mb-2">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
              <p>Clave de Acceso</p>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="pl-3">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <vs-input disabled class="inputx w-1/3" placeholder="Disabled" id="meeting_url_input" v-model="activeConsultationModal.meeting_password"/>
              <vs-button class="ml-3" color="primary" type="filled" icon="content_copy"
                v-clipboard:copy="activeConsultationModal.meeting_password"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              ></vs-button>

            </vs-col>
          </vs-row>
          <vs-divider class="mt-6 mb-5" />
          <vs-row vs-type="flex" vs-justify="center">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <vs-button color="primary" size="small" type="filled" icon="add_link" 
                v-clipboard:copy="'Link de Acceso: '+activeConsultationModal.meeting_url_base+' Contraseña: '+activeConsultationModal.meeting_password"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                Compartir Link de Acceso Público y Contraseña</vs-button>
            </vs-col>
          </vs-row>
          <vs-divider class="mt-6 mb-5" />
          <vs-row vs-type="flex" vs-justify="center" class="mb-6">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <vs-button color="#2E88F7" size="large" type="filled" icon-pack="fa" icon="fa-video" @click="goLink(activeConsultationModal.meeting_url);">Acceder como Administrador</vs-button>
            </vs-col>
          </vs-row>
    </modal>
    <modal
          name="editStatusModal"
          height="auto"
          width="50%"
          :scrollable="true"
          style="z-index: 1005;"
        >
          <vs-row vs-w="12" class="p-4">
            <vs-col vs-type="flex" class="my-6" vs-justify="center" vs-align="center" vs-w="12">
              <h3>Editar estatus de la consulta #{{activeConsultationModal.id}}</h3>
            </vs-col>
          </vs-row>
          <vs-divider class="my-1" />
          <vs-row vs-w="12" class="">
            <vs-col vs-type="flex" class="my-6" vs-justify="center" vs-align="center" vs-w="12" v-if="activeConsultationModal.meta">
              <h4>Estatus actual: {{activeConsultationModal.meta.status}}</h4>
            </vs-col>
          </vs-row>
          <vs-divider class="my-1" />
          <vs-row vs-w="12" class="mb-6">
            <vs-col vs-type="flex" class="my-6" vs-justify="center" vs-align="center" vs-w="12">
              <!-- dropdown -->
              <vs-dropdown v-if="activeConsultationModal.meta">
                <vs-button class="btn-drop" :color="getOrderStatusColor(currentConsultationStatus)" type="filled" icon="expand_more">{{currentConsultationStatus}}</vs-button>
                <vs-dropdown-menu>
                    <vs-dropdown-item v-if="activeConsultationModal.meta.status !== 'Nueva'" @click="setStatus('Nueva')"> Nueva </vs-dropdown-item>
                    <vs-dropdown-item v-if="activeConsultationModal.meta.status !== 'Solicitud'" @click="setStatus('Solicitud')"> Solicitud </vs-dropdown-item>
                    <vs-dropdown-item v-if="activeConsultationModal.meta.status !== 'Confirmada'" @click="setStatus('Confirmada')"> Confirmada </vs-dropdown-item>
                    <vs-dropdown-item v-if="activeConsultationModal.meta.status !== 'Re-Confirmada'" @click="setStatus('Re-Confirmada')">Asistirá</vs-dropdown-item>
                    <!-- 
                      if (status === 'Nueva')   return 'warning'
                      if (status === 'Solicitud') return 'warning'
                      if (status === 'Confirmada') return '#00a7e1'
                      if (status === 'Re-Confirmada') return '#0034A1'
                      if (status === 'Completado') return 'success'
                      if (status === 'Pendiente Confirmar')  return 'danger'
                      if (status === 'Pendiente Resultados')  return 'danger'
                     -->
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
            <vs-col vs-type="flex" class="my-6" vs-justify="center" vs-align="center" vs-w="12">
              <vs-button class="normal" @click="updateEventStatus(activeConsultationModal, currentConsultationStatus)">Guardar</vs-button>
            </vs-col>
          </vs-row>          
    </modal>
    <modal
                    name="formSubmittedModal"
                    height="auto"
                    width="50%"
                    style="z-index: 1001;"
                  >
                    <div class="p-4">
                      <div class="vx-row ">
                        <div class="mt-3 mb-4 vx-col w-full flex flex-col items-center">
                          <img src="@/assets/images/logo/logo.png" style="width: 70px; height: 70px;" >
                        </div>
                        <div class="mb-4 vx-col w-full flex flex-col text-center">
                          <h3>Inicio de Consulta</h3>
                        </div>
                        <div class="mb-4 mt-5  vx-col w-full flex flex-col items-center">
                          <vs-button  class="w-1/2" color="primary" type="filled" icon="dashboard" @click="patientInfo(dataRowId)">Llenar Formulario del paciente</vs-button>
                          <vs-button  class="mt-3 w-1/2" color="success" type="filled" icon="check" @click="$router.push('/consultations/newConsultation/?consultationId='+dataRowId)">Iniciar Consulta</vs-button>
                        </div>
                      </div>
                    </div>
                  </modal>
  </div>
</template>

<script>

import DataViewSidebar from '../ui-elements/data-list/DataViewSidebar.vue'

import Datepicker from 'vuejs-datepicker'
import { en, es } from 'vuejs-datepicker/src/locale'
import vSelect from 'vue-select'
import moment from 'moment'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
const ES = require("flatpickr/dist/l10n/es.js").default.es;

import VueClipboard from 'vue-clipboard2'

// import modules

export default {
  components: {
    DataViewSidebar,
    vSelect,
    Datepicker,
    flatPickr
  },
  data () {
    return {
      patientFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.first_name.toLowerCase().indexOf(temp) > -1 || 
      option.last_name.toLowerCase().indexOf(temp) > -1 ||
      option.email.toLowerCase().indexOf(temp) > -1 
      },
      activeConsultationModal: {},
      currentConsultationStatus: '',
      currClinic: {},
      current: 1,
      dataRowId: null,
      isSecretary: false,
      activeDoctorData: {},
      selected: [],
      edittingEvent: false,
      edittingId: null,
      rowObject: null,
      eventData: {
        eventType: 'consulta',
        title: null,
        notes: null,
        duration: 60,
        notification: true,
        date: null,
        timeType: 'normal',
        clinic_id: null,
        patient_id: null,
        doctor_id: null,
        zoom_email: null,
        zoom_jwt: null,
        clinicType: 'presencial',
        hour: ""
        
      },
      eventDataDef: {
        eventType: 'consulta',
        title: null,
        notes: null,
        duration: 60,
        notification: true,
        date: null,
        timeType: 'normal',
        clinic_id: null,
        patient_id: null,
        doctor_id: null,
        zoom_email: null,
        zoom_jwt: null,
        clinicType: 'presencial',
        hour: ""
        
      },
      configdateTimePicker2: {
        enableTime: true,
        dateFormat: 'Z',
        altInput: true,
        altFormat: 'd M Y - h:i K',
        defaultDate: new Date(),
        minDate: new Date(),
      },
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'm-d-Y',
        altInput: true,
        altFormat: 'd M Y',
        defaultDate: new Date(),
        minDate: new Date(),
        locale: ES
      },
      registerPatient: false,
      notifyPatient: false,
      newPatient: {
        first_name: null,
        last_name: null,
        email: null,
        dob: null,
        gender: null,
        phone: [null,null],
        notification_prefs: ['email'],
        address: null,
        address_2: null,
        zone: null,
        city: null,
        country: null,
        role: 'patient',
        idType: null,
        idNum: null
      },
      newPatientDef: {
        first_name: null,
        last_name: null,
        email: null,
        dob: null,
        gender: null,
        phone: [null,null],
        notification_prefs: ['email'],
        address: null,
        address_2: null,
        zone: null,
        city: null,
        country: null,
        role: 'patient',
        idType: null,
        idNum: null
      },
      newEventErrors: {
        clinic: false,
      },
      products: [
        {
          name: 'Christian Mayorga',
          category: 'Link',
          order_status: 'Pendiente Confirmar',
          new_rec: 'Recurrente',
          popularity: 10,
          time: "09:45 PM",
          date: "25/11/2020",
          price: 150
        }
      ],
      itemsPerPage: 4,
      isMounted: false,
      langEs: es,
      disabledFrom: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {
        sidebarTitle: null,
      }
    }
  },
  computed: {
    // AVAILABILITY
    availability (){
      // console.log(this.$store.state.schedule);
      return this.$store.state.schedule
    },
    clinicAvailabilityByDate (){
      return this.$store.state.clinicAvailabilityByDate
    },
    // EVOLUGY
    docClinics () {
      let currentClinics = this.$store.state.clinics;
      // obtener clinicas virtuales de zoom y que esten activas
      var zoomClinics = this.findZoomClinics();
      // console.log('Zoom Clinics: ',zoomClinics);

      if (zoomClinics.length > 0){
        // console.log('clinics: ',currentClinics);
        return currentClinics;
      } else {
        // si no ha activado 
        let defaultVirtual = new Object();
        defaultVirtual.title = 'Clinica Virtual Zoom',
        defaultVirtual.meta = {"type":"Virtual", "zoom_active":"false"}
        return [defaultVirtual, ...currentClinics];
      }
    },
    patientsList (){
      return this.$store.state.patients
    },
    consultationsList (){
      // return this.$store.state.consultations
      let activeConsultations = this.$store.state.consultations.filter(obj => {
        return ( obj.meta.status && obj.meta.status.toLowerCase() == 'nueva' )
          || ( obj.meta.status && obj.meta.status.toLowerCase() == 'confirmada' )
          || ( obj.meta.status && obj.meta.status.toLowerCase() == 're-confirmada' )
          || ( obj.meta.status && obj.meta.status.toLowerCase() == 'solicitud' )
          || ( obj.meta.status && obj.meta.status.toLowerCase() == 'signos vitales' );
      });
      
      activeConsultations.sort(function compare(a, b) {
        var dateA = new Date(a.date);
        var dateB = new Date(b.date);
        return dateA - dateB;
      });

      var todayUTC = new Date();
      var today = new Date();
      var tomorrowUTC = new Date();
      var nextWeek = new Date();

      todayUTC.setHours(todayUTC.getHours() - 6);
      today.setHours(17, 59, 59);

      tomorrowUTC.setDate(todayUTC.getDate() + 1);
      tomorrowUTC.setHours(17, 59, 59);

      nextWeek.setDate(todayUTC.getDate() + 365);
      nextWeek.setDate(17, 59, 59)

      //var todayGMT6 = new Date(todayUTC.setHours(23));
      //var tomorrow = new Date(todayGMT6.setDate(todayGMT6.getDate() + 1))
      //inmediatamente despues de la hora
        let lateConsultation = activeConsultations.filter(obj => {
          return ( obj.date < todayUTC.toISOString() );
        });
        let todayConsultation = activeConsultations.filter(obj => {
          return ( obj.date >= todayUTC.toISOString() && obj.date < today.toISOString())
        })
         //maximo un dia
        let immediateConsultation = activeConsultations.filter(obj => {
          return ( obj.date > today.toISOString() && obj.date < tomorrowUTC.toISOString());
        })
        let futureConsultation = activeConsultations.filter( obj => {
          return ( obj.date > tomorrowUTC.toISOString() && obj.date < nextWeek.toISOString());
          })
      console.log(todayUTC.toISOString(), today.toISOString(), todayConsultation)
      console.log(lateConsultation)
      return [activeConsultations, lateConsultation, futureConsultation, immediateConsultation, todayConsultation];
    },
    consultType (activeConsultations, type) {
      var todayUTC = new Date();
      var tomorrowUTC = new Date();
      var nextWeek = new Date();

      todayUTC.setHours(todayUTC.getHours() - 6);

      tomorrowUTC.setDate(todayUTC.getDate() + 1);
      tomorrowUTC.setHours(17, 59, 59);

      nextWeek.setDate(todayUTC.getDate() + 7);
      nextWeek.setDate(17, 59, 59)

      //var todayGMT6 = new Date(todayUTC.setHours(23));
      //var tomorrow = new Date(todayGMT6.setDate(todayGMT6.getDate() + 1))
      if (type == 'atrasada') { //inmediatamente despues de la hora
        var finalConsultation = activeConsultations.filter(obj => {
          return ( obj.date < todayUTC.toISOString() );
        });
      } else if (type == 'proximas') { //maximo un dia
        var finalConsultation = activeConsultations.filter(obj => {
          return ( obj.date > todayGMT6.toISOString() && obj.date < tomorrowUTC.toISOString());
        })
      }
        else if (type == 'lejanas') {
          var finalConsultation = activeConsultations.filter( obj => {
            return ( obj.date > tomorrowUTC.toISOString() && obj.date < nextWeek.toISOString());
          })
        }
      
      return finalConsultation;
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    findZoomClinicsActive(){
      console.log('CLINICSS: ',this.$store.state.clinics);
      let zoomClinics = this.$store.state.clinics.filter(obj => {
        return ( obj.meta.type && obj.meta.type.toLowerCase() == 'virtual' )
          
          && (obj.meta.zoom_active && obj.meta.zoom_active.toLowerCase() == 'true');

      });
      console.log(zoomClinics);
      return zoomClinics
    },
    // -------
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table && this.consultationsList ? this.$refs.table.queriedResults.length : this.consultationsList.length
    },
    getCountries(){
      return CSP.getCountries();
    },
    getStates(){
      return CSP.getStates(this.newPatient.country.code);
    },
  },
  mounted(){

  },
  watch: {
    'eventData.patient_id': function(newVal, oldVal) {
      if(this.eventData.patient_id){
        var patient = this.patientsList.filter(obj => {
          return obj.id === this.eventData.patient_id
        });
        console.log(patient);
        this.eventData.title = 'Cita con '+patient[0].first_name+' '+patient[0].last_name;
      }  else {
        this.eventData.title = '';
      }   
    },
    
    'eventData.date': function(newVal, oldVal) {
      // creating request payload
      console.log(newVal);
      try {
          var DateSelected = new Date(newVal.replace(/-/g, "/"));
          var DateAfter = new Date(DateSelected);
      } catch (error) {
          var DateSelected = new Date(newVal);
          var DateAfter = new Date(DateSelected);
          console.error(error);
      }
      
      DateAfter.setDate(DateAfter.getDate()+1);
      this.eventData.hour = null;
      
      // -------- fetching clinic schedule by date --------
      var fetchClinicSchedule_payload = new Object();
      fetchClinicSchedule_payload.clinic_id = this.eventData.clinic_id,
      fetchClinicSchedule_payload.start_date = DateSelected.toISOString().split('T')[0]+'T06:00',
      fetchClinicSchedule_payload.end_date = DateAfter.toISOString().split('T')[0]+'T05:59',
      fetchClinicSchedule_payload.requestDate = new Date().toISOString().substring(0,16),
      fetchClinicSchedule_payload.eventLength = this.eventData.duration;

      if(this.eventData.clinic_id && this.eventData.duration){
        this.$store.dispatch('fetchClinicSchedule', fetchClinicSchedule_payload).then(response => {
          console.log('RESPONSE: ',response);
        }, error => {
            console.error(error);
        }); 
      }
    },
    'eventData.clinic_id': function(newVal, oldVal) {
      console.log(`Cabmio clinica: new:${newVal} old:${oldVal}`);
      this.eventData.date = null;
      let currClinic = this.$store.state.clinics.filter(obj => {
        return ( obj.id  ==  newVal )
      });
      this.currClinic =  currClinic[0];
      console.log(this.currClinic)
    }
  },
  methods: {
    showModalParam(id) {
      this.rowObject = id
      this.dataRowId = id.id;
      this.$modal.show('formSubmittedModal');
    },
    patientInfo() {
      let routeData = this.$router.resolve('/links/new-patient/503/?pid='+this.rowObject.patient.id);
      window.open(routeData.href, '_blank');
      $router.push('/consultations/newConsultation/?consultationId='+this.rowObject.patient.id)
    },
    cleanEventData(){
      this.eventData.clinic_id = null,
      this.eventData.patient_id = null
      this.eventData.eventType = "consulta",
      this.eventData.title = null,
      this.eventData.notes = null,
      this.eventData.duration = !this.isSecretary ? 
        this.eventData.duration = this.activeUserInfo.meta.consultationLength ? this.activeUserInfo.meta.consultationLength : 60 : 
        this.eventData.duration = this.activeDoctorData.meta.consultationLength ? this.activeDoctorData.meta.consultationLength : 60,
      this.eventData.notification = true,
      this.eventData.date = null,
      this.eventData.timeType = 'normal',
      this.eventData.clinic_id = null,
      this.eventData.patient_id = null,
      this.eventData.doctor_id = null,
      this.eventData.zoom_email = null,
      this.eventData.zoom_jwt = null,
      this.eventData.clinicType = "presencial";
    },
    convertUTC_TIME(dateSTR){
      var d = new Date(dateSTR);
      var time = d.getHours();
      return ("00" + time).slice(-2) + ":" +("00" + d.getMinutes()).slice(-2) + `${time > 12 ? "PM": "AM"}`
    },
    editEvent(event){
      console.log(event)
      //this.$modal.hide('viewEventModal');
      this.edittingEvent = true,
      this.edittingId = event.id,
      console.log(this.edittingId)
      this.eventData.eventType = event.type,
      this.eventData.title = event.title,
      this.eventData.notes = event.notes ? event.notes : '',
      this.eventData.duration = event.duration ? event.duration : 60,
      this.eventData.notification = event.notification,
      // this.eventData.date = event.date,
      this.eventData.timeType = 'normal',
      this.eventData.clinic_id = event.clinic_id ? event.clinic_id : null,
      this.eventData.patient_id = event.patient_id ? event.patient_id : null,
      this.eventData.doctor_id = event.doctor_id,
      this.eventData.zoom_email = null,
      this.eventData.zoom_jwt = null,
      this.eventData.clinicType = null;
      // console.log(this.eventData);
      this.$modal.show('editEventModal');
    },
    editStatus(event){
      this.$modal.show('editStatusModal');
      console.log(event);
      this.activeConsultationModal = event;
      this.currentConsultationStatus = this.activeConsultationModal.meta.status;
    },
    setStatus(newStatus){
      this.currentConsultationStatus = newStatus;
    },
    updateEventStatus(event, newStatus){
      var payload = new Object();
      payload.event_id = event.id;
      payload.meta = {...event.meta, ...{status: newStatus}};
      this.$store.dispatch('editEvent',payload).then(response => {
        
        // console.log(response);
        if(newStatus == 'Re-Confirmada'){
          this.$store.dispatch('notifyReConfirmationSuccess', event).then((response2) => { 
            console.log('notificacion: ', response2);
            setTimeout(() => {
              this.showAlert('success','Estatos de consulta actualizado','Consulta actualizada de: '+event.meta.status+' a: '+newStatus);
              this.$modal.hide('editStatusModal');
            }, 700);         
          }).catch(function (error) {
              console.log(error);
          });
        } else {
            setTimeout(() => {
              this.showAlert('success','Estatos de consulta actualizado','Consulta actualizada de: '+event.meta.status+' a: '+newStatus);
              this.$modal.hide('editStatusModal');
            }, 900);   
        }
        

      });
    },
    executeEditEvent(){
      // console.log(this.eventData);
      
      let newEventObj = new Object();
      newEventObj.event_id = this.edittingId;
      // event type
      if( this.eventData.eventType == 'consulta' && this.eventData.clinicType == 'presencial') {        

        newEventObj.type = 'consultation',
        newEventObj.clinic_id = this.eventData.clinic_id,
        newEventObj.patient_id = this.eventData.patient_id,
        newEventObj.meta = {"status": "Nueva"},
        newEventObj.duration = parseInt(this.eventData.duration);

      } else if (this.eventData.eventType == 'recordatorio') {
        
        newEventObj.type = 'appointment';
        

      } else if (this.eventData.eventType == 'evento') {
        newEventObj.type = 'meeting';
        newEventObj.duration = parseInt(this.eventData.duration);
        
      }

      newEventObj.title = this.eventData.title,
      newEventObj.notes = this.eventData.notes ? this.eventData.notes : null,
      
      newEventObj.notification = this.eventData.notification;
      
      // newEventObj.doctor_id = this.activeUserInfo.id;

      
      try {
          var d = new Date(this.eventData.date.replace(/-/g, "/"));
      } catch (error) {
          var d = new Date(this.eventData.date);
          console.error(error);
      }
      
      d.setHours(this.eventData.hour.split(':')[0],this.eventData.hour.split(':')[1].substring(0,2));
    
      newEventObj.date = d.getFullYear()+ "-" + ("00" + (d.getMonth() + 1)).slice(-2) + "-" +("00" + d.getDate()).slice(-2)+"T"+ ("00" + (d.getHours())).slice(-2) + ":" +("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2)
      
      this.$store.dispatch('editEvent',newEventObj).then(response => {
            this.eventData = this.eventDataDef;
            
            this.showAlert('success','Evento editado','Evento editado éxitosamente!');
            // console.log(response);
            if(true) {
              this.$store.dispatch('sendNotificationEventEditted', response.data.data.event.id).then(response => {
              // console.log(response);
              this.showAlert('success','Paciente Notificado','El paciente fue notificado.');
               }, error => {
              console.error(error);
              }); 
            }            

            // send notification to patient, anouncing that event was modified
            this.cleanEventData();
            this.$modal.hide('editEventModal');

    
            // fullCalendarRef.addEvent(tempObj);   

        }, error => {
            console.error(error);
            this.showAlert('danger','Error al editar consulta',error.response.data.error);
        });
    },
    cancelEditEvent(){
      this.$modal.hide('editEventModal');
      //this.$modal.show('viewEventModal');
    },
    openEditEvent (event) {
      const e = this.$store.getters['calendar/getEvent'](event.id)
      this.id = e.id
      this.title = e.title
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.url = e.url
      this.labelLocal = e.label
      this.activePromptEditEvent = true
    },
    getWeekDays() {
      if(this.activeUserInfo) {
        if(this.activeUserInfo.role == "doctor"){
           if(this.activeUserInfo.meta && this.activeUserInfo.meta.weekDays) {
            const weekDays = this.activeUserInfo.meta.weekDays;
            return Array.isArray(weekDays) ? weekDays : null
          }
        } else {
          if(this.activeDoctorData.meta && this.activeDoctorData.meta.weekDays) {
            const weekDays = this.activeDoctorData.meta.weekDays;
            return Array.isArray(weekDays) ? weekDays : null
          }
        }
      }
      return [];
    },
    getSchedule(currentDate) {
      let day = moment(currentDate, 'MM-DD-YYYY').day();
      // day = day == 0 ? 7 : day;
      const weekDays = this.getWeekDays();
      return weekDays ? weekDays.find(item => item.id ==day) : null;
    },
    // VALIDATION
    validateNewPatient(){
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('new-patient').then(result => {
          if (result) {
            this.addNewPatient();
            resolve(true);
          } else {
            reject('correct all values')
          }
        })
      })
    },
    // VALIDATION
    validateAddNewEvent(type){
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('new-event').then(result => {
          if (result) {
            if(type == 'add'){
              this.addNewEvent();
            } else if(type == 'edit'){
              this.executeEditEvent();
            }
            resolve(true);
          } else {
            reject('correct all values')
          }
        })
      })
    },
    // VALIDATION
    validateAddNewPatient() {
        this.$modal.hide('newPatientModal')
    },
    // actions
    addNewEvent () {
      console.log('eventData: ',this.eventData);
      console.log('currClinic: ', this.currClinic);

      let newEventObj = new Object();
      var isVirtual, zoomJTW, zoomEmail;

      if(this.currClinic.meta.type.toLowerCase() == 'virtual'){
        zoomJTW = this.activeUserInfo.role == "doctor" ? this.activeUserInfo.meta.zoom_jwt : this.activeDoctorData.zoom_jwt;
        zoomEmail = this.activeUserInfo.role == "doctor" ? this.activeUserInfo.meta.zoom_email : this.activeDoctorData.zoom_email;
        isVirtual = true;
        console.log('es virtual')
        newEventObj.zoom_jwt = zoomJTW,
        newEventObj.zoom_email = zoomEmail,
        // 
        newEventObj.type = 'virtual_consultation',
        newEventObj.clinic_id = this.eventData.clinic_id,
        newEventObj.patient_id = this.eventData.patient_id,
        newEventObj.meta = {"status": "Nueva"},
        newEventObj.duration = parseInt(this.eventData.duration);

      } else  {
        // 
        newEventObj.type = 'consultation',
        newEventObj.clinic_id = this.eventData.clinic_id,
        newEventObj.patient_id = this.eventData.patient_id,
        newEventObj.meta = {"status": "Nueva"},
        newEventObj.duration = parseInt(this.eventData.duration);

      } 
      
      // now allowed here
      // if (this.eventData.eventType == 'recordatorio') {
        
      //   newEventObj.type = 'appointment';
        

      // } else if (this.eventData.eventType == 'evento') {
      //   newEventObj.type = 'meeting';
      //   newEventObj.duration = parseInt(this.eventData.duration);
        
      // }

      newEventObj.title = this.eventData.title,
      newEventObj.notes = this.eventData.notes ? this.eventData.notes : null,
      
      newEventObj.notification = this.eventData.notification,
      
      newEventObj.doctor_id = this.activeUserInfo.role == "doctor" ?  this.activeUserInfo.id : sessionStorage.getItem('activeDoctorId');
      
      
      // parsing data
      try {
          var d = new Date(this.eventData.date.replace(/-/g, "/"));
      } catch (error) {
          var d = new Date(this.eventData.date);
          console.error(error);
      }
      
      d.setHours(this.eventData.hour.split(':')[0],this.eventData.hour.split(':')[1].substring(0,2));
    
      newEventObj.date = d.getFullYear()+ "-" + ("00" + (d.getMonth() + 1)).slice(-2) + "-" +("00" + d.getDate()).slice(-2)+"T"+ ("00" + (d.getHours())).slice(-2) + ":" +("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2)
      
      console.log(newEventObj);
      this.$store.dispatch('addEvent',newEventObj).then(response => {
            console.log('Nuevo Evento: ', response);
            this.showAlert('success','Consulta Agregada','Consulta Agregada éxitosamente!');
            this.$modal.hide('newEventModal');
            this.cleanEventData();
            this.$store.dispatch('fetchEvents').then(response => {
              console.log(response);
              //console.log(this.eventsList);
            }, error => {
              console.error(error);
            }); 
        }, error => {
            console.error(error);
            if(isVirtual && error.response.data.error == 'Request failed with status code 401'){
              this.showAlert('danger','Error en credenciales de Zoom', 'Es posible que las credenciales de zoom están mal, verifica en: <br> ajustes->ajustes->conexiones', 6);
            } else {
              this.showAlert('danger','Error al agregar consulta',error.response.data.error);
            }
            
        });
    },
    addNewPatient(){
      
      // console.log(this.newPatient);
      let newPatientObj = new Object();
      newPatientObj.address = this.newPatient.address,
      this.newPatient.first_name ? newPatientObj.first_name = this.newPatient.first_name : null,
      this.newPatient.last_name ? newPatientObj.last_name = this.newPatient.last_name : null,
      this.newPatient.dob ? newPatientObj.dob = this.newPatient.dob : null,
      this.newPatient.gender ? newPatientObj.gender = this.newPatient.gender : null,
      this.newPatient.phone ? newPatientObj.phone = this.newPatient.phone : null,
      this.newPatient.notification_prefs ? newPatientObj.notification_prefs = this.newPatient.notification_prefs : null,
      this.newPatient.address ? newPatientObj.address = this.newPatient.address : null,
      this.newPatient.address_2 ? newPatientObj.address_2 = this.newPatient.address_2 : null,
      this.newPatient.zone ? newPatientObj.zone = this.newPatient.zone : null,
      this.newPatient.city ? newPatientObj.city = this.newPatient.city : null,
      this.newPatient.country ? newPatientObj.country = this.newPatient.country.name : null,
      this.newPatient.role ? newPatientObj.role = this.newPatient.role : null;
      this.newPatient.email ? newPatientObj.email = this.newPatient.email : newPatientObj.email = 'paciente+' + newPatientObj.phone[0] + '@evolugy.com'

      newPatientObj.active =  false;
      newPatientObj.phone[0] = '502' + this.newPatient.phone[0]

      this.newPatient.idType && this.newPatient.idNum ? 
        this.newPatient.sub_specialty = this.newPatient.idType+' | '+this.newPatient.idNum : null;
      console.log(this.newPatient.phone)
      this.$store.dispatch('addPatient',newPatientObj).then( response => {
            // console.log(response);
            // limpiar inputs
            this.newPatient.first_name = null, this.newPatient.last_name = null,  this.newPatient.email = null,
            this.newPatient.phone[0] = null, this.newPatient.phone[1] = null;
            // 
            
            this.eventData.patient_id = response.data.data.user.id;
            this.eventData.title =  'Cita con '+response.data.data.user.first_name+' '+response.data.data.user.last_name;

            this.showAlert('success','Paciente Agregado','Paciente con ID#'+response.data.data.user.id+' Agregado éxitosamente!');
            this.newPatient = this.newPatientDef;

            var notifPayload = {
              doctor_name : this.activeUserInfo.role == "doctor" ? this.activeUserInfo.first_name+' '+this.activeUserInfo.last_name 
                : this.activeDoctorData.first_name+' '+this.activeDoctorData.last_name,
              patient_id: response.data.data.user.id,
              patient_name: response.data.data.user.first_name+' '+response.data.data.user.last_name,
              doctor_id: this.activeUserInfo.role == "doctor" ?  this.activeUserInfo.id : sessionStorage.getItem('activeDoctorId'),
              email: response.data.data.user.email,
              phone: response.data.data.user.phone

            } 
            // this.$store.dispatch('sendNotificationNewPatient', notifPayload);
          
            this.$modal.hide('newPatientModal');
        }).catch((error) => {
          console.log(error.response);
          if(error.response.data.error == 'The email address is already in use by another account.') {
              
              console.log('...ya existe....');

              this.$modal.hide('newPatientModal');
              
              this.$store.dispatch('fetchAllUsers').then(userResponse => {
                console.log(userResponse);
                const matchUser = userResponse.data.data.users.find(user => user.email === newPatientObj.email);

                if(matchUser && matchUser.role === 'patient') {
                  const linkPayload = { email: newPatientObj.email, doctor_id: this.isSecretary ? sessionStorage.getItem('activeDoctorId') : this.activeUserInfo.id };

                    this.$store.dispatch('linkUser', linkPayload).then( (response) =>{
                        this.showAlert('success','Paciente Vinculado Exitosamente!',
                          'Paciente: '+matchUser.first_name + ' '+ matchUser.last_name+'  Correo: '+matchUser.email );

                    }, error => {
                      if(error.response.data.error == 'The users were linked previously') {
                        this.showAlert('danger','Este paciente ya fue vinculado.',error.response.data.error);
                      } else {
                        console.error(error);
                      }
                      
                    });
                } else {
                  this.showAlert('danger','No es posible vincular este usuario porque no es un paciente.',error.response.data.error);
                }
              });
            }
            else {
              this.showAlert('danger','Error al agregar paciente.',error.response.data.error);
            }
        });      
    },
    showAlert (color,title,text, time = 3) {
      this.$vs.notify({
        time: time*1000,
        color: color,
        title: title,
        text: text
      })
    },
    goSettings(){
      window.open('/profile/settings/?activeTab=connections', '_blank');
    },
    findZoomClinics(){
      let zoomClinics = this.$store.state.clinics.filter(obj => {
        return ( obj.meta.type && obj.meta.type.toLowerCase() == 'virtual' )

          && (obj.meta.zoom_active);

      });
      return zoomClinics
    },
    addNewData () {
      this.sidebarData = {}
      this.sidebarData.sidebarTitle = 'Agregar';
      this.toggleDataSidebar(true)
    },
    deleteData (id) {
      this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.sidebarData.sidebarTitle = 'Editar';
      this.toggleDataSidebar(true)
    },
    getOrderStatusColor (status) {
      if (status === 'Nueva')   return 'warning'
      if (status === 'Signos Vitales') return 'success'
      if (status === 'Solicitud') return 'warning'
      if (status === 'Confirmada') return '#00a7e1'
      if (status === 'Re-Confirmada') return '#0034A1'
      if (status === 'Completado') return 'success'
      if (status === 'Pendiente Confirmar')  return 'danger'
      if (status === 'Pendiente Resultados')  return 'danger'
      return 'primary'
    },
    getOrderTypeColor (type) {
      if (type === 'consultation')   return '#0033a1'
      if (type === 'virtual_consultation') return '#00a7e1'
      return 'primary'
    },
    getOrderTypeTxt (type) {
      if (type === 'consultation')   return 'Consulta'
      if (type === 'virtual_consultation') return 'Virtual'
      return 'no identificado'
    },
    getDateString(date){
      let newDate = new Date(date);
      let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      return newDate.toLocaleDateString('es-ES', options);
    },
    getTimeString(date){
      // hay que arreglarlo.
      let newDate = new Date(date);
      let options = {hour: '2-digit', minute:'2-digit', hour12: true};
      return newDate.toLocaleTimeString('en-EN', options);
    },
    getPopularityColor (num) {
      if (num > 90)  return 'success'
      if (num > 70)  return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50)  return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    goWP(patientNum, consultationId, patientId){
      
      var doctorId = this.activeUserInfo.role == "doctor" ?  this.activeUserInfo.id : sessionStorage.getItem('activeDoctorId');

      window.open('https://api.whatsapp.com/send?phone=502'+patientNum+'&text=No%20te%20olvides%20de%20confirmar%20tu%20consulta:%20https://app.evolugy.com/links/consultation/'+consultationId+'?action=confirm', '_blank');
    },
    goZM(data){
      this.activeConsultationModal = data;
      setTimeout(() => {
        this.$modal.show('zoomModal');        
      }, 50);
      // window.open('https://us05web.zoom.us/j/82145287043?pwd=K1V1d28xL1dtNVA5MHMrWVNpMzJkZz09', '_blank');
    },
    goLink(link){
      window.open(link, '_blank');
    },
    toClip(){
     
    },
    onCopy: function (e) {
        this.showAlert('success','Link Copiado a Portapapeles', e.text);
    },
    onError: function (e) {
        alert('Failed to copy the text to the clipboard')
        this.showAlert('danger','Error copianto link al portapapeles', e);
    },
    getFormattedDate(date) {
      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      
      return month + '-' + day + '-' + year;
    },
  },
  beforeCreate (){

    
  },
  created () {
    
  },
  beforeMount (){
    this.$store.dispatch('fetchClinics');
    if( this.activeUserInfo.role == "secretaria" ){
        this.isSecretary = true;
        console.log('ES SECRETARIA');
        this.$store.dispatch('getDoctorDataById', sessionStorage.getItem('activeDoctorId')).then(response=>{
          this.activeDoctorData = JSON.parse(JSON.stringify(response.data.data.user));
          this.eventData.duration = this.activeDoctorData.meta.consultationLength ? this.activeDoctorData.meta.consultationLength : 60 ;
          this.eventDataDef.duration = this.activeDoctorData.meta.consultationLength ? this.activeDoctorData.meta.consultationLength : 60;
        }, error => {
          console.error(error);
        });
      } else {
        this.isSecretary = false;
        this.eventData.duration = this.activeUserInfo.meta.consultationLength ? this.activeUserInfo.meta.consultationLength : 60;
        this.eventDataDef.duration = this.activeUserInfo.meta.consultationLength ? this.activeUserInfo.meta.consultationLength : 60;
      }
  },
  mounted () {
    this.isMounted = true
    // Dispatch fetch actions
    
    this.$store.dispatch('fetchPatients');
    this.$store.dispatch('fetchEvents');
    // SCHEDULE TIMETABLE
    var schedulePayload = new Object();
    schedulePayload.date = this.getFormattedDate(new Date());

    this.$store.dispatch('buildSchedule', schedulePayload).then(response => {
      console.log(response);
    }, error => {
        console.error(error);
    }); 
  },
  beforeDestroy (){
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

    .zoom:hover {
      transform: scale(1.2); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
    }
    .zoom {
      transition: transform .3s; /* Animation */
    }
  }
  .overflow {
    overflow:visible;
  }
  .style-chooser .vs__dropdown-menu {
    max-height: 200px;
  }
}
</style>
